var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c("PageHeader", {
        attrs: {
          title: _vm.roleName,
          subtitle: "Manage tenant permissions and settings",
          "no-padding": "",
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        _vm._l(_vm.sections, function (section, index) {
          return _c(
            "v-card-text",
            { key: `section-${index}` },
            [
              _c("v-subheader", { staticClass: "title" }, [
                _vm._v(_vm._s(section.name)),
              ]),
              _vm._v(" "),
              _c(
                "v-layout",
                { staticClass: "my-3", attrs: { wrap: "" } },
                _vm._l(section.routes, function (route, routeIndex) {
                  return _c(
                    "v-flex",
                    {
                      key: `route-${routeIndex}`,
                      staticClass: "pa-3",
                      attrs: { xs12: "", sm6: "", md4: "", lg4: "" },
                    },
                    [
                      _c("TileNavigationButton", {
                        attrs: {
                          title: route.name,
                          to: route.to,
                          icon: route.icon,
                        },
                      }),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }